import { BreadCrumb } from "primereact/breadcrumb";
import React from "react";
import styled from "styled-components";
import {
  CompletedMenuItem,
  CustomMenuItem,
  completeMenuItem,
  isPathSelected,
} from "../../business-components/nav/MenuItems/completeMenuItem";
import { HOME_PATH } from "../../constants/CvpPathsAndParams";
import { isAppTypeIframe } from "../../getAppType";
import { path } from "../../url/WSRouter";

export interface CvpBreadCrumbProps {
  breadcrumbItems: CustomMenuItem[];
  className?: string;
}

export const CvpBreadCrumb = (props: CvpBreadCrumbProps) => {
  let {
    breadcrumbItems: items,
    className = "cvp-card-breadcrumb",
    ...rest
  } = props;

  const _items = items.map(completeMenuItem);

  let homeItem: CompletedMenuItem | null = null;
  if (!isAppTypeIframe()) {
    homeItem = completeMenuItem({
      path: HOME_PATH,
      icon: "pi pi-fw pi-home",
      label: "",
      isSelected: () => isPathSelected([path("/"), path("frontpage")]),
    });
  }

  return (
    <StyledBreadCrumb
      {...rest}
      home={homeItem}
      model={_items}
      className={className}
    />
  );
};

const StyledBreadCrumb = styled(BreadCrumb)`
  &.p-breadcrumb {
    background: transparent;
    padding: 0;
    font-size: 0.9em;
    border: 1px solid transparent;

    min-height: 4.5rem;
    display: flex;
    align-items: center;
  }

  .p-breadcrumb-list {
    max-width: 100%;
  }

  &.p-breadcrumb .p-breadcrumb-list li:not(:last-child) .p-menuitem-text {
    color: var(--text-color-secondary);
  }
  &.p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {
    color: var(--primary-color);
    font-weight: 500;
  }

  &.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-icon {
    color: var(--text-color-secondary);
  }

  // make the middle breadcrumb shrink
  .p-menuitem:not(:last-child):not(.p-breadcrumb-home) {
    overflow: hidden;

    min-width: 0;
    flex-shrink: 999999;

    .p-menuitem-text {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: normal;
    }
  }

  .p-menuitem-separator:last-child {
    display: none;
  }

  .p-breadcrumb-list .p-menuitem-separator:first-child {
    display: none;
  }

  &.cvp-card-breadcrumb.cvp-card-breadcrumb__no-padding {
    padding: 0;
  }
`;
